import { render, staticRenderFns } from "./SessionList.vue?vue&type=template&id=a53a0520&scoped=true&"
import script from "./SessionList.vue?vue&type=script&lang=js&"
export * from "./SessionList.vue?vue&type=script&lang=js&"
import style0 from "./SessionList.vue?vue&type=style&index=0&id=a53a0520&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53a0520",
  null
  
)

export default component.exports